import React from 'react';
import { OverlayComponent } from 'app/components';
import { hasTranslationsValid } from 'app/components/translation/has-translations-valid';
import { validateSubscriberGroup } from '../utils/validate-subscriber-group';
import { SubscriberGroupContainerProps } from '../types';
import { SubscriberGroupStickyHeader } from './subscriber-group-sticky-header';

export const SubscriberGroupContainer: React.FC<SubscriberGroupContainerProps> = ({
  actionType, formState, shouldPrompt, mainLanguage, translation, children, switchTranslationsToggle,
  saveSubscriberGroup, mergeSubscriberGroupItem, updateValidation, displayError
}) => {

  const { subscriberGroupItem, fetching, saving, languageOptions, validation } = formState;

  const onSave = () => {
    const formValidation = validateSubscriberGroup(subscriberGroupItem, languageOptions, translation);

    updateValidation({ ...validation, ...formValidation });

    if (Object.keys(formValidation).length > 0) {
      !hasTranslationsValid(formValidation.language, mainLanguage) && switchTranslationsToggle(true);
      displayError(translation.subscriber_group_validation_error);
      return;
    }

    saveSubscriberGroup(subscriberGroupItem);
  };

  const subscriberGroupName = subscriberGroupItem.language
    ?.find(languageItem => languageItem.value === mainLanguage)
    ?.description;

  return <>
    <OverlayComponent
      displayOverlay={saving}
      overlayText={saving
        ? translation.saving_subscriber_group
        : translation.deleting_subscriber_group} />
    <SubscriberGroupStickyHeader
      actionType={actionType}
      shouldPrompt={shouldPrompt}
      subscriberGroupItem={subscriberGroupItem}
      name={subscriberGroupName}
      mergeSubscriberGroupItem={mergeSubscriberGroupItem}
      fetching={fetching}
      displayError={displayError}
      onSave={onSave}
      translation={translation} />
    {children}
  </>;
};
